import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectItemsModule } from '@src/app/shared/select-items';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '@src/app/components';

import { BusinessTypesComponent } from './components/business-types/business-types.component';
import { JobTitlesComponent } from './components/job-titles/job-titles.component';

@NgModule({
  declarations: [BusinessTypesComponent, JobTitlesComponent],
  imports: [CommonModule, SelectItemsModule, TranslateModule, ComponentsModule],
  exports: [BusinessTypesComponent, JobTitlesComponent],
})
export class DictionariesModule {}
